import React from "react";
import '../Loader/waitingloader.css'
const WaitingLoder = () => {
  return (
    <React.Fragment>
    <div className="waitModal">
      <div className="waitingLoader"></div>
      </div>
    </React.Fragment>
  );
};
export default WaitingLoder


// WEBPACK FOOTER //
// ./src/Modules/Loader/waitingLoader.jsx